import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'

import { Typeahead } from 'react-bootstrap-typeahead'
import { FormGroup, ControlLabel, Button } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import { editUser } from '../../login/reducers/manageLogin'

class EditUserRoleAndTeam extends Component {
	state = {
		selectedUser: [],
		selectedRole: [],
		selectedTeam: [],
	}

	_renderMenuItemChildren = (user, props, index) => {
		// THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
		return [
			<div key="name" search={props.text}>
				<strong>{user.first_name} {user.last_name}</strong>
			</div>,
			<div key="email">
				<small>
					Email: {user.email ? user.email : "N/A"}
				</small>
			</div>,
		]
	}

  teamLabelKey = (team) => {
    if (team.subgroup) {
      return `${team.name} - ${team.subgroup}`
    }
    return team.name
  }

	handleSelectUser = (selectedUser) => {
    // The react-bootstrap-typeahead component looks for an array for selected elements rather than an object
		if (!selectedUser || selectedUser.length === 0) {
      return this.setState({
        selectedUser: [],
        selectedRole: [],
        selectedTeam: [],
      })
		}

    let selectedRole = []
    let selectedTeam = []

    if (selectedUser[0] && selectedUser[0].role) {
      selectedRole = [selectedUser[0].role]
    }

    if (selectedUser[0] && selectedUser[0].team) {
      selectedTeam = [selectedUser[0].team]
    }

		this.setState({ 
      selectedUser, 
      selectedRole,
      selectedTeam,
    })
	}

	saveUserRoleAndTeam = () => {
    const { selectedUser, selectedRole, selectedTeam } = this.state

		if (selectedUser.length === 0) {
			return
		}

    const user = selectedUser[0]

    let role, team
    
    if (selectedRole.length > 0) {
      role = selectedRole[0]
    }
    
    if (selectedTeam.length > 0) {
      team = selectedTeam[0]
    }

		swal({
			text: "Saving user's role and team...",
			icon: require("../../../static/images/spinner.gif"),
			button: false
		})

		axios({
			method: "PATCH",
      url: user.url,
			headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
			data: { 
        role: role ? role.url : null, 
        team: team ? team.url : null,
      }
		})
    .then(response => {
      swal({
        title: "Success",
        text: "The user's role and team have been updated",
        icon: "success",
        button: "Continue",
      })
      const updatedUser = {
        ...response.data,
        role,
        team,
      }
      this.props.editUser(updatedUser)
    })
    .catch(error => {
      const message = "There was an error editing the user's role and team"
      handleErrorFetchingData(error, message)
    })
	}

	render() {
    const { selectedUser, selectedRole, selectedTeam } = this.state
		const { users, roles, teams } = this.props

		const sortedUsers = users.filter(user => user.is_active).sort((a, b) => {
			const userA = `${a.first_name} ${a.last_name}`
			const userB = `${b.first_name} ${b.last_name}`
			return userA.localeCompare(userB)
		})


		return (
			<div id='EditUserClients'>
				<h4 style={{ display: 'inline-block' }}>
					Edit a User's Role and Team
				</h4>

				<FormGroup>
					<ControlLabel>
						Select User
					</ControlLabel>
					<Typeahead
						id='SelectedUserTypeahead'
            clearButton
						labelKey={user => `${user.first_name} ${user.last_name}`}
						options={sortedUsers}
						selected={selectedUser}
						onChange={this.handleSelectUser}
						renderMenuItemChildren={this._renderMenuItemChildren}
					/>
				</FormGroup>

				{this.state.selectedUser.length ?
					<FormGroup>
						<ControlLabel>
							Select Role
            </ControlLabel>
						<Typeahead
							id='EditUserTeamTypeahead'
              clearButton
							labelKey={role => role.name}
							options={roles}
							selected={selectedRole}
							onChange={(selectedRole) => this.setState({ selectedRole })}
							placeholder="Select role"
						/>
						<br />
						<ControlLabel>
							Select Team
            </ControlLabel>
						<Typeahead
							id='EditUserTeamTypeahead'
              clearButton
							labelKey={this.teamLabelKey}
							options={teams}
							selected={selectedTeam}
							onChange={(selectedTeam) => this.setState({ selectedTeam })}
							placeholder="Select team"
						/>
						<br />
						<Button
							bsStyle="primary"
              onClick={this.saveUserRoleAndTeam}
						>
							Save
            </Button>
					</FormGroup>
					:
					null
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		users: state.manageLogin.users,
		roles: state.manageLogin.roles,
		teams: state.manageLogin.teams,
	}
}

export default connect(mapStateToProps, { editUser })(EditUserRoleAndTeam)



// WEBPACK FOOTER //
// ./src/routes/manager/components/EditUserRoleAndTeam.js